import React from 'react';
import ReactDOM from 'react-dom';
import App from 'containers/App';
import * as serviceWorker from 'serviceWorker';
import { BrowserRouter } from 'react-router-dom';

import 'assets/styles/index.scss';
import 'antd/dist/reset.css';

ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById('root'),
);

serviceWorker.register();
